import { z } from 'zod'

/**
 * Consent choices captured from the cookie banner.
 * - `essential` is always true (cannot be refused - required for the site to work).
 * - `analytics` / `marketing` / `preferences` are opt-in buckets for any future tooling.
 */
export const ConsentChoicesSchema = z.object({
  essential: z.literal(true),
  analytics: z.boolean(),
  marketing: z.boolean(),
  preferences: z.boolean(),
})

export type ConsentChoices = z.infer<typeof ConsentChoicesSchema>

export const LogConsentRequestSchema = z.object({
  choices: ConsentChoicesSchema,
  consent_version: z.string().min(1).max(32).default('v1'),
  gpc_signal: z.boolean().default(false),
  session_id: z.string().min(8).max(128),
  ip_country: z.string().length(2).optional(),
})

export type LogConsentRequest = z.infer<typeof LogConsentRequestSchema>

export const LogConsentResponseSchema = z.object({
  id: z.string().uuid(),
  created_at: z.string(),
})

export type LogConsentResponse = z.infer<typeof LogConsentResponseSchema>
